import { TOptionsEvents } from 'keen-slider';
import { useKeenSlider } from 'keen-slider/react';
import React, { useCallback, useEffect, useState } from 'react';
import { TRENDING_AUTHORS_SLIDES_COUNT } from '../../../constants/slidesByBreakpoint';
import { shiftSlidesInCarousel } from '../../../helpers/shiftSlidesInCarousel';
import { order_by } from '../../../lib/generatedGraphqlClient/zeus';
import { Chain } from '../../../lib/getGraphqlClient';
import { TrendingAuthorsSlider } from './TrendingAuthorsSlider';
import { TrendingAuthorsType } from './TrendingAuthors.types';

type TrendingAuthorsProps = {
  trendingAuthorDescription: string;
};
export function TrendingAuthors({ trendingAuthorDescription }: TrendingAuthorsProps) {
  const [options, setOptions] = useState<TOptionsEvents>({});
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [loadMore, setLoadMore] = useState(true);
  const [authors, setAuthors] = useState<TrendingAuthorsType[]>([]);
  const [offset, setOffset] = useState(0);
  const [sliderRef, slider] = useKeenSlider<HTMLDivElement>(options);
  const [rightAlignBreakpoint, setRightAlignBreakpoint] = useState(5);

  const fetchAuthors = async (offset: number) => {
    const response = (
      await Chain().query({
        voyce_author_profiles: [
          {
            offset: offset,
            limit: 15,
            order_by: [{ total_popularity: order_by.desc_nulls_last }]
          },
          {
            id: true,
            user_id: true,
            views_count: true,
            followers_count: true,
            user: {
              id: true,
              username: true,
              avatar: true
            }
          }
        ]
      })
    ).voyce_author_profiles;

    if (response) {
      setAuthors(prevAuthors => [...prevAuthors, ...response]);
    } else {
      console.log('something went wrong');
    }
    setIsLoading(false);
    setLoadMore(false);
  };

  useEffect(() => {
    fetchAuthors(offset);
  }, [offset]);

  const onLoadMore = useCallback((shift: number) => {
    setLoadMore(true);
    setOffset(prevOffset => prevOffset + shift);
  }, []);

  const shiftPage = useCallback(
    (dir: 'left' | 'right') => {
      slider.moveToSlideRelative(shiftSlidesInCarousel(slider.details(), dir, 1), true);
      setRightAlignBreakpoint(
        slider.details().relativeSlide + slider.details().slidesPerView / 2
      );
    },
    [slider]
  );

  return (
    <div className="lg:w-full space-y-3 text-white">
      <div className="flex flex-row justify-between items-start w-full mb-8">
        <div className="flex flex-col justify-between items-start w-2/3 ssm:ml-4">
          <h1
            className="trendingauthors-title flex justify-start lg:text-4xl
           sm:text-2xl ssm:text-xl sm:w-1/2 mb-3"
          >
            Trending Creators
          </h1>
          <p className="trendingauthors-description flex w-full justify-start text-base">
            {trendingAuthorDescription}
          </p>
        </div>
        <div className="flex justify-end items-center lg:space-x-2 md:space-x-4 sm:space-x-4 ssm:space-x-4 mr-5">
          <div
            className="flex items-center justify-center h-10 w-10 bg-gray cursor-pointer rounded-full hover:bg-white group"
            onClick={() => shiftPage('left')}
          >
            <svg
              className="stroke-current text-white group-hover:text-black"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.6665 2.66675L5.33317 8.00008L10.6665 13.3334"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div
            className="flex items-center justify-center h-10 w-10 bg-gray cursor-pointer rounded-full hover:bg-white group"
            onClick={() => shiftPage('right')}
          >
            <svg
              className="stroke-current text-white group-hover:text-black"
              width="8"
              height="14"
              viewBox="0 0 8 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.33301 1.66667L6.66634 7L1.33301 12.3333"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
      {!isLoading ? (
        <TrendingAuthorsSlider
          authors={authors}
          slider={slider}
          sliderRef={sliderRef}
          rightAlignBreakpoint={rightAlignBreakpoint}
          onLoadMore={onLoadMore}
          slidesByBreakpoint={TRENDING_AUTHORS_SLIDES_COUNT}
          setOptions={setOptions}
        />
      ) : (
        <div>Loading Trending Creators</div>
      )}
    </div>
  );
}
